import { Component, EventEmitter, Host, HostBinding, HostListener, Input, OnInit, Output, inject } from '@angular/core';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

import { ENVIRONMENT, Environment } from '@environment';

import { HourItem } from '../showtime-streaming-in-cinemas/performance/performance.component';

@Component({
  selector: 'ush-ui-hour',
  styleUrls: ['./ui-hour.component.scss'],
  template: `
    <div>
      <div class="attributes-wrapper">
        @if (attributesEnabled) {
          @for (attr of hour?.attributes; track attr) {
            <ush-ui-attribute *ngIf="attr" [attribute]="attr"></ush-ui-attribute>
          }
        }
      </div>

      <span>{{ hour?.hour }}</span>
      <span class="hour-description" *ngIf="hour?.showtimeStatusMessage">{{ hour?.showtimeStatusMessage?.label }}</span>
      <div
        class="showtime-description"
        *ngIf="hour?.showtimeDescription"
        [innerHTML]="hour?.showtimeDescription | safe: 'html'"
      >
        {{ hour?.showtimeDescription }}
      </div>
    </div>
    <fa-icon [icon]="arrowRightIcon"></fa-icon>
  `
})
export class UiHourComponent implements OnInit {
  @HostBinding('id') id!: string;
  @HostBinding('type') type = 'button';
  @HostBinding('role') role = 'button';
  @HostBinding('tabindex') tabindex = '0';
  @HostBinding('class.disabled') get disabledClass() {
    return this.hour.disabled;
  }

  @HostListener('click') onClick() {
    if (this.hour.disabled) return;
    this.hourSelected.emit(this.hour);
  }

  @HostListener('keydown.enter') onEnter() {
    if (this.hour.disabled) return;
    this.hourSelected.emit(this.hour);
  }

  @HostListener('keyup', ['$event']) onKeyup(event: KeyboardEvent) {
    // on arrows right or left move focus to the next or previous hour
    const target = event.target as HTMLElement;
    if (event.key === 'ArrowRight') {
      const nextSibling = target?.nextElementSibling as HTMLElement;
      if (nextSibling) {
        nextSibling?.focus();
      } else {
        const parent = target?.parentElement as HTMLElement;
        const firstChild = parent?.firstElementChild as HTMLElement;
        firstChild?.focus();
      }
    }
    if (event.key === 'ArrowLeft') {
      const previousSibling = target?.previousElementSibling as HTMLElement;
      if (previousSibling) {
        previousSibling?.focus();
      } else {
        const parent = target?.parentElement as HTMLElement;
        const lastChild = parent?.lastElementChild as HTMLElement;
        lastChild?.focus();
      }
    }
  }

  private _hour: HourItem;

  get hour(): HourItem {
    return this._hour;
  }

  @Input() set hour(hour: HourItem) {
    this._hour = hour;
    this.id = `performance-${hour.performance}`;
  }

  @Output() hourSelected = new EventEmitter<HourItem>();

  arrowRightIcon = faArrowRight;
  attributesEnabled = false;
  private env: Environment = inject(ENVIRONMENT);

  ngOnInit(): void {
    this.attributesEnabled =
      this.env.showtimeStreamingConfig?.performanceHourAttributes != false && this.hour.attributes?.length > 0;
  }
}
